<template>
  <div>
    <div class="md:border md:rounded mb-4 ">
      <div class="flex justify-between items-center py-2 px-0 md:px-6">
        <label for="name" class="block text-lg font-medium leading-6 text-gray-900">Settings</label>
        <div class="space-x-1 flex items-center">
          <dropdown-button ref="dropdownButton" v-if="isSupportUser && eventShowType">
            <span slot="link" class="inline-flex items-center rounded-md border border-transparent px-2 py-1 text-sm font-medium leading-4 text-gray-700 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM12.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0zM18.75 12a.75.75 0 11-1.5 0 .75.75 0 011.5 0z" />
              </svg>
            </span>
            <div slot="dropdown" class="w-64 bg-white border shadow rounded-md overflow-hidden text-center divide-y divide-gray-200 text-sm">
              <div v-if="isSuperUser" class="">
                <merge-divisions :displayType="'dropdown-item'" :class_list_id ="eventShowType.class_list_id" :shows="adminData.event.shows.filter(s => s.entry_details_id === eventShowType.event_show_type_id)"/>
              </div>
              <!--<div v-if="hasOldAnimalID && isSuperUser" class="" role="none">
                <button class="text-gray-900 group flex w-full items-center px-2 py-2 text-xs text-gray-800 hover:bg-gray-200">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12" />
                  </svg>
                  Upgrade Entry Type
                </button>
              </div>-->
              <div class="py-1" role="none">
                <button class="text-gray-900 group flex w-full items-center px-2 py-2 text-xs text-gray-800 hover:text-white hover:bg-red-500" @click="deleteShowType(eventShowType)">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mr-3 w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                  </svg>
                  Delete Entry Type
                </button>
              </div>
            </div>
          </dropdown-button>
        </div>
      </div>
      <div class="flex border-b flex-col md:flex-row justify-start items-center flex-wrap px-0 md:px-6 pb-2">
        <div class="flex space-x-2 items-center md:w-72 w-full md:mr-3">
          <div v-if="isSupportUser" class="w-full">
            <div class="relative">
              <label for="name" class="block flex items-center text-sm font-medium leading-6 text-gray-900">Label
                <span v-tooltip="{content: 'Unique label to help exhibitors identify/choose which type of entry to add.', classes: ['w-128', 'p-2']}" class="inline-flex items-center rounded-md bg-gray-400/10 px-2 py-0.5 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-400/20">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                  </svg>
                </span>
              </label>
              <input type="text" name="name" id="name" class="text-lg peer block border border-gray-400 bg-white px-2 rounded py-1 mt-1 text-gray-900 focus:ring-0 sm:leading-6 w-full" placeholder="Jane Smith" v-model="eventShowType.label" @change="saveEventShowType">
              <div class="absolute inset-x-0 bottom-0 border-t_ border-gray-400 peer-focus:border-t-2 peer-focus:border-indigo-600" aria-hidden="true"></div>
            </div>
          </div>
          <div v-else class="w-full">
            <div class="relative">
              <label for="name" class="block flex items-center text-sm font-medium leading-6 text-gray-900">Label
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ml-1 w-3 h-3">
                  <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clip-rule="evenodd" />
                </svg>
                <span v-tooltip="{content: 'Unique label to help exhibitors identify/choose which type of entry to add.', classes: ['w-128', 'p-2']}" class="inline-flex items-center rounded-md bg-gray-400/10 px-2 py-0.5 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-400/20">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                  </svg>
                </span>
              </label>
              <input disabled type="text" name="name" id="name" class="text-lg peer block border border-gray-400 bg-gray-100 cursor-not-allowed px-2 rounded py-1 mt-1 text-gray-900 focus:ring-0 sm:leading-6 w-full" placeholder="Jane Smith" v-model="eventShowType.label" @change="saveEventShowType">
              <div class="absolute inset-x-0 bottom-0 border-t_ border-gray-400 peer-focus:border-t-2 peer-focus:border-indigo-600" aria-hidden="true"></div>
            </div>
          </div>
        </div>
        <div class="md:w-64 w-full md:mr-3">
          <div class="flex justify-between">
            <label for="group" class="block flex items-center text-sm font-medium leading-6 text-gray-900">Group
              <span v-if="!isSupportUser">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ml-1 w-3 h-3">
                  <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clip-rule="evenodd" />
                </svg>
              </span>
              <span v-tooltip="{content: 'Group together similar Entry Types to help organize entries for exhibitors.', classes: ['w-128', 'p-2']}" class="inline-flex items-center rounded-md bg-gray-400/10 px-2 py-0.5 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-400/20">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                </svg>
              </span>
            </label>
            <button v-if="isSupportUser" class="btn-link text-xs" @click="$refs.newGroup.show()">+ Group</button>
          </div>
          <v-select
              class="bg-white rounded py-1 w-full"
              v-model="eventShowType.group_type"
              :options="eventShowTypeGroups"
              :clearable="false"
              :disabled="!isSupportUser"
              @input="saveEventShowType"
            >
            </v-select>
        </div>
        <div class="w-full md:w-40 md:mr-3">
          <label for="class_list" class="block text-sm font-medium leading-6 text-gray-900">
            <span class="mr-2">Status</span>
            <!--<template v-if="eventShowType.status !== 'ADMIN'">
              <span class="inline-flex items-center rounded-full bg-green-100 px-2 py-0 text-xs font-medium text-green-700 ring-1 ring-inset border border-green-600 border-opacity-25">ACTIVE</span>
            </template>
            <template v-else>
              <span class="inline-flex items-center rounded-full bg-red-100 px-2 py-0 text-xs font-medium text-red-700 ring-1 ring-inset border border-red-600 border-opacity-25">ADMIN ONLY</span>
            </template>-->
          </label>
          <v-select
              class="bg-white rounded py-1 w-full"
              v-model="eventShowType.status"
              @input="saveEventShowType"
              :options="statusOptions"
              label="label"
              :reduce="option => option.value"
              :clearable="false"
            >
            </v-select>
        </div>
      </div>
      <div class="flex flex-col md:flex-row justify-start items-start md:space-x-3 py-2 px-0 md:px-6">
        <div v-if="!hasOldAnimalID && !entryTypeIsShowmanship" class="w-full md:w-72">
          <div class="flex justify-between">
            <label for="group" class="block flex items-center text-sm font-medium leading-6 text-gray-900">Animal ID Field
              <span v-if="!isSupportUser">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ml-1 w-3 h-3">
                  <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clip-rule="evenodd" />
                </svg>
              </span>
              <span v-tooltip="{content: 'Each entry type is required to have an ID field to help determine unique entries. A nickname or barn name field can be used if you don\'t require any formal identification. To change the ID field you need to make sure it has been added below.', classes: ['w-128', 'p-2']}" class="inline-flex items-center rounded-md bg-gray-400/10 px-2 py-0.5 text-xs font-medium text-gray-700 ring-1 ring-inset ring-gray-400/20">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
                </svg>
              </span>
            </label>
          </div>
          <v-select
              class="bg-white rounded py-1 w-full"
              v-model="eventShowType.class_calc.animal_id_field"
              :options="eventShowType.entry_details[0].fields.filter(f => ((f.inputType === 'text' || f.inputType === 'number') && getFieldType(f) !== 'EXHIBITOR' && f.model !== 'weight' && f.required))"
              :reduce="option => option.model"
              :clearable="false"
              :disabled="!isSupportUser"
              @input="saveAnimalIDField"
            >
            </v-select>
        </div>
        <div v-if="usesWeight" class="w-full md:w-40">
          <div class="flex justify-between">
            <label for="group" class="block flex items-center text-sm font-medium leading-6 text-gray-900">Use Declared Weight?
              <span v-if="!isSupportUser">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ml-1 w-3 h-3">
                  <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clip-rule="evenodd" />
                </svg>
              </span>
            </label>
          </div>
          <v-select
              class="bg-white rounded py-1 md:w-32"
              v-model="eventShowType.class_calc.declared_weight"
              :options="[{label: 'Yes', model: true}, {label: 'No', model: false}]"
              :reduce="option => option.model"
              :clearable="false"
              :disabled="!isSupportUser"
              @input="saveEventShowType"
            >
            </v-select>
        </div>
        <div v-if="eventShowType.class_calc.declared_weight"  class="w-full md:w-64">
          <div class="flex justify-between">
            <label for="group" class="block flex items-center text-sm font-medium leading-6 text-gray-900">Declared Weight Hint Text
              <span v-if="!isSupportUser">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="ml-1 w-3 h-3">
                  <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clip-rule="evenodd" />
                </svg>
              </span>
            </label>
          </div>
          <input v-model="eventShowType.class_calc.declared_weight_hint" class="text-xs peer block border border-gray-400 bg-white px-2 rounded py-1 mt-1 text-gray-900 focus:ring-0 sm:leading-6 w-full" @change="saveEventShowType"/>
        </div>
        <!--<div>
          <div class="flex justify-between">
            <label for="group" class="block text-sm font-medium leading-6 text-gray-900">Require manual breed on: (choose breeds that require to be specified?)<span v-if="!isSuperUser">(Locked)</span></label>
          </div>
          <v-select
              class="bg-white rounded py-1 md:w-64"
              v-model="eventShowType.class_calc.animal_id_field"
              :options="eventShowType.entry_details[0].fields"
              :clearable="false"
              :disabled="!isSuperUser"
              @input="saveEventShowType"
            >
            </v-select>
        </div>-->
      </div>
      <div v-if="!isSupportUser" class="flex items-start md:items-center pb-2 px-0 md:px-6 text-gray-800">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="mr-1 w-3 h-3">
          <path fill-rule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clip-rule="evenodd" />
        </svg>
        <p class="text-xs">- Please contact your show specialist with questions on these settings.</p>
      </div>
    </div>
    <div class="flex flex-col justify-start px-0 w-full border-t sm:border sm:rounded">
      <div class="w-full px-0 sm:px-6 py-8">
        <add-edit-entry-fields :eventShowType="eventShowType" :entryFields="entryFields" @save="saveEventShowType"></add-edit-entry-fields>
      </div>
    </div>
    <b-modal ref="newGroup" title="New Group" hide-footer @close="newGroup=null">
      <div>
        <label for="GROUP" class="block text-sm font-medium leading-6 text-gray-900">GROUP</label>
        <div class="relative mt-2">
          <input type="text" name="name" id="name" class="rounded-sm text-xl w-72 peer block border-0 bg-gray-200 px-2 py-1.5 text-gray-900 focus:ring-0 sm:leading-6" placeholder="New Group" v-model="newGroup">
        </div>
      </div>
      <div class="flex justify-end space-x-3 items-center">
        <button @click="addNewGroup" class="btn btn-green">Save</button>
        <button @click="() => { $refs.newGroup.hide(); newGroup = null}" class="btn-xs btn-red-outline">Cancel</button>
      </div>
    </b-modal>

  </div>
</template>

<script>

import MergeDivisions from '@/components/admin/classListConfig/MergeDivisions.vue'
import AddEditEntryFields from '@/components/admin/showEntryTypes/AddEditEntryFields.vue'
export default {
  components: {
    MergeDivisions,
    AddEditEntryFields
  },
  props: {
    eventShowType: {
      default: () => {
        return {}
      },
      type: Object
    },
    entryFields: Array
  },
  data () {
    return {
      originalEntryFields: [],
      statusOptions: [
        {label: 'Admin Only', value: 'ADMIN'},
        {label: 'Entries Active', value: null}
      ],
      addedGroups: [],
      newFieldType: null,
      newGroup: null
    }
  },
  computed: {
    currentUser () {
      return this.$store.state.user
    },
    isSuperUser () {
      return this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2'
    },
    event () {
      return this.$store.state.admin.adminData.event
    },
    isAssesmentUser () {
      if (this.currentUser.user_id === 'KFtUZcXZ1ITCICo8w0kZdJHB65n1' && this.event.event_id === 'ce97824c-1df8-11ef-8e5d-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'PaFB62Hpp4V3BlrUFebP3MRNi0g2' && this.event.event_id === '1d7af7ce-1e10-11ef-b2db-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'MhDTB3YTmTgMZB9g2lVoflY1luO2' && this.event.event_id === '636ee696-1e10-11ef-ad80-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'gsXtVouX3HUQZM8qvrVTa2efLOK2' && this.event.event_id === 'a3e57334-1e10-11ef-a269-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === '3PyICPP8s3OPx7F7BIvV3kRx1OD3' && this.event.event_id === 'bd174d14-1e10-11ef-bd1d-1248ddbb6de9') {
        return true
      } else if (this.currentUser.user_id === 'ECXhYgYtmnUmN8i19kP5vZp5Ulj2' && this.event.event_id === '6f670c58-e7ba-11ee-b65a-1248ddbb6de9') {
        return true
      } else {
        return false
      }
    },
    isSupportUser () {
      return this.currentUser.role === 'ADMIN' || this.isSuperUser || this.isAssesmentUser
    },
    adminData () {
      return this.$store.state.admin.adminData
    },
    eventShowTypeGroups () {
      let groups = []
      this.adminData.event_show_types.forEach(et => {
        if (!groups.includes(et.group_type)) {
          groups.push(et.group_type)
        }
      })
      this.addedGroups.forEach(g => {
        if (!groups.includes(g)) {
          groups.push(g)
        }
      })
      return groups
    },
    eventShowTypeShows () {
      if (this.eventShowType) {
        return this.adminData.event.shows.filter(s => this.eventShowType.event_show_type_id === s.entry_details_id)
      }
      return []
    },
    eventShowTypeSpecies () {
      if (this.eventShowTypeShows.length > 0) {
        return this.eventShowTypeShows[0].species
      } else {
        return null
      }
    },
    eventShowTypeClassConfig () {
      return this.adminData.class_configurations.filter(cc => cc.class_configuration_id === this.eventShowType.class_list_id)[0]
    },
    eventShowTypeClassList () {
      // return this.adminData.event.show_types.filter(st => st.class_list_id === this.eventShowType.class_list_id)[0].class_list
      let est = this.adminData.event.show_types.filter(st => st.class_list_id === this.eventShowType.class_list_id)[0]
      if (est) {
        return est.class_list
      } else {
        return null
      }
    },
    usesWeight () {
      if (!this.eventShowTypeClassList) {
        return false
      }
      let weightClass = this.eventShowTypeClassList.filter(c => c.break_type === 'weight')
      return weightClass.length > 0
    },
    hasOldAnimalID () {
      return this.eventShowType.entry_details[0].fields.filter(f => f.model === 'animal_id').length > 0
    },
    entryTypeIsShowmanship () {
      return this.eventShowType.label.toLowerCase().includes('showmanship')
    }
  },
  methods: {
    deleteShowType: function (showType) {
      this.$store.state.apiInstance.post(`${process.env.VUE_APP_ROOT_API}/deleteShowEntryType`, {event_show_type_id: showType.event_show_type_id})
        .then(response => {
          let index = this.adminData.event_show_types.findIndex(et => et.event_show_type_id === showType.event_show_type_id)
          this.adminData.event_show_types.splice(index, 1)
          this.notie.alert({
            type: 2,
            text: `Show Entry Type Deleted`
          })
          this.$emit('deleted')
        })
    },
    selectEntryType (showType) {
      // Update Entry Fields
      this.eventShowType = JSON.parse(JSON.stringify(showType))
      if (this.eventShowTypeSpecies) {
        this.$store.state.apiInstance.get(`${process.env.VUE_APP_ROOT_API}/getSpeciesTypeEntryFields/${this.eventShowTypeSpecies}`)
          .then(response => {
            this.entryFields = response.data.data
          })
      }
    },
    saveEventShowType: function () {
      this.eventShowType.name = 'event_show_types'
      if (!this.eventShowType.event_show_type_id) {
        this.$store.dispatch('addData', this.eventShowType)
          .then(response => {
            this.notie.alert({
              type: 1,
              text: `Entry Type Successfully Saved`
            })
            this.$emit('saved')
          })
          .catch(() => {
            // this.$honeybadger.notify(error)
            this.notie.alert({
              type: 3,
              text: `Error creating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          })
      } else {
        this.$store.dispatch('updateData', this.eventShowType)
          .then(response => {
            this.notie.alert({
              type: 1,
              text: `Entry Type Updated`
            })
            this.$emit('saved')
          })
          .catch(() => {
            this.notie.alert({
              type: 3,
              text: `Error Updating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
            })
          })
      }
    },
    saveAnimalIDField () {
      this.saveEventShowType()
      // Also trigger a check to update any entries already in the system...
      this.$store.state.apiInstance.post(`${process.env.VUE_APP_ROOT_API}/updateAnimalIDField`, {event_show_type_id: this.eventShowType.event_show_type_id, animal_id_field: this.eventShowType.class_calc.animal_id_field})
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Animal ID Field Updated`
          })
        })
        .catch(() => {
          this.notie.alert({
            type: 3,
            text: `Error Updating Animal ID Field, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    addNewGroup () {
      this.newGroup = this.newGroup.toUpperCase()
      this.eventShowType.group_type = this.newGroup
      this.addedGroups.push(this.newGroup)
      this.$refs.newGroup.hide()
      this.newGroup = null
      this.saveEventShowType()
    },
    addNewEntryTypeClicked () {
      this.newEntryType = {
        label: '',
        group_type: '',
        status: 'ACTIVE',
        entry_details: []
      }
      this.$refs.newEntryType.show()
    },
    saveNewEntryType () {
      this.newEntryType.name = 'event_show_types'
      this.newEntryType.identifier = this.newEntryType.label
      this.$store.dispatch('addData', this.newEntryType)
        .then(response => {
          this.notie.alert({
            type: 1,
            text: `Entry Type Updated`
          })
          this.newEntryType.event_show_type_id = response.data.data.event_show_type_id
          this.$emit('saved')
        })
        .catch(() => {
          this.notie.alert({
            type: 3,
            text: `Error Updating Entry Type, please check all fields and try again.<br>You can send an email to <b>${process.env.VUE_APP_SUPPORT_EMAIL}</b> if the error continues.`
          })
        })
    },
    getFieldType (f) {
      if (f.new_field) {
        return 'NEW'
      } else if (f.series_field) {
        return 'SERIES'
      } else if (f.exhibitor_field) {
        return 'EXHIBITOR'
      } else if (this.entryFields.filter(ef => ef.model === f.model).length > 0) {
        return 'SPECIES'
      } else {
        return 'CUSTOM'
      }
    }
  }
}
</script>

<style>

</style>
